import { useAtom } from '@dbeining/react-atom';
import { Navigate, useLocation } from 'react-router-dom';
import { userAtom } from '../../atoms';
import { IRole } from '../../customTypings/user/Role';

const PrivateRoute = ({ 
    children, 
    roles,
}: { 
    children: JSX.Element,
    roles?: Array<string>;
}) => {
    let location = useLocation();
    const currentUser = useAtom(userAtom)
    if (!currentUser) {
        // not logged in so redirect to login page with the return url
        return <Navigate to="/signin" state={{ from: location }} />
    }

    // Check if 2FA setup is required but not completed
    if (currentUser.advisories && currentUser.advisories.twoFaSetupRequired) {
        // User needs to complete 2FA setup before accessing protected routes
        return <Navigate to="/twofactorSetup" state={{ from: location }} />
    }

    // check if route is restricted by role
    if (roles && !currentUser.identity.roles.some((role: IRole) => (roles.indexOf(role.name) >= 0 ))) {
        // role not authorised so redirect to home page
        return <Navigate to={{ pathname: '/'}} />
    }

    // authorised so return component
    return children
}

export default PrivateRoute;
